import { getCarListV2, FuzzySearch } from '@/api/domain/cars'
import CARDICT from '@/store/dict/carDict.js'
import { dict2list } from '@/utils/index'
import { h } from 'vue'
import { TABS, tabList } from './index'

export const OPERATES = ['lookCarDetail', 'editCar', 'outCar', 'returnCar', 'careCar', 'fixCar', 'accidentCar', 'prepareCar', 'addInsure', 'addLicense', 'confirmCarInStore', 'dealCar', 'cancelPrepareCar', 'carInfoSubmit']

// 待处理配置
export const WaitForHandleConfig = (table, isCompany, autoQuery, operations, getTags) => {
  return {
    formData: {
      list: [{
        el: 'select',
        itemConfig: {
          label: '车牌号',
          prop: 'plateNo',
        },
        elConfig: {
          remote: true,
          clearable: true,
          filterable: true,
          reserveKeyword: true,
          defaultFirstOption: true,
          remoteMethod: (query) => {
            const keyWords = query.trim()
            if (keyWords.length > 3) {
              FuzzySearch({
                plateNo: query.trim(),
                state: 1,
              }).then((res) => {
                const { data } = res
                table.value.setItemData({
                  elConfigKey: 'list',
                  key: 'plateNo',
                  data: data || [],
                })
              })
            }
          },
          placeholder: '请输入',
          options: {
            label: 'plateNo',
            value: 'id',
            list: [],
          },
        },
      }, {
        el: 'input',
        itemConfig: {
          label: 'VIN码',
          prop: 'vin',
        },
        elConfig: {
          clearable: true,
          maxlength: 18,
          placeholder: '请输入',
        },
      }, {
        el: 'input',
        itemConfig: {
          label: '车辆ID',
          prop: 'id',
        },
        elConfig: {
          clearable: true,
          placeholder: '请输入车辆ID',
        },
        directives: [{ name: 'number', arg: 'integer', value: 18 }],
      }, {
        el: 'input',
        itemConfig: {
          label: '发动机号',
          prop: 'engineNo',
        },
        elConfig: {
          clearable: true,
          maxlength: 18,
          placeholder: '请输入',
        },
      }, {
        itemConfig: {
          prop: 'brandSeriesModel',
        },
        elConfig: {
          showModel: true,
        },
        render: 'CarBrandSeriesModel',
      }, {
        el: 'select',
        itemConfig: {
          label: '车辆标签',
          prop: 'tagId',
        },
        elConfig: {
          clearable: true,
          placeholder: '请选择',
          filterable: false,
          options: {
            label: 'name',
            value: 'id',
            list: [],
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '车源方',
          prop: 'providerId',
        },
        elConfig: {
          clearable: true,
          placeholder: '请选择',
          options: {
            label: 'name',
            value: 'id',
            list: [],
          },
        },
        isShow: isCompany.value,
      }, {
        el: 'select',
        itemConfig: {
          label: '车辆调拨状态',
          prop: 'transferState',
        },
        elConfig: {
          clearable: true,
          placeholder: '请选择',
          filterable: false,
          options: {
            label: 'label',
            value: 'value',
            list: dict2list(CARDICT.VEHICLE_TRANSFER_STATE()),
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '电池冷却类型',
          prop: 'coolingMode',
        },
        elConfig: {
          clearable: true,
          placeholder: '请选择',
          filterable: false,
          options: {
            label: 'label',
            value: 'value',
            list: dict2list(CARDICT.VEHICLE_COOLING_MODE()),
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '所属公司',
          prop: 'companyId',
        },
        render: 'company-select',
        isShow: !isCompany.value,
      }],
      exportData: {
        // 导出模板，用于查找对应的导出方法
        // export.js文件中需存在以'export{{exportTemplate}}'命名的导出方法，例如：exportReturnCarOrderList
        exportTemplate: 'CarList',
        // 导出的文件名称
        filename: '车辆管理.xlsx',
        // 资源权限（可选）
        permissionName: 'car_vehicle_export',
      },
      clickSearch: () => {
        getTags && getTags()
      },
      dealWithSearch: (params) => {
        // 品牌车型车系参数处理
        const { brandSeriesModel, companyId } = params
        if (brandSeriesModel) {
          const { brandId, seriesId, modelId } = brandSeriesModel
          params.seriesId = seriesId
          params.carModelId = modelId
          params.brandId = brandId
        }
        if (companyId) {
          params.companyIdList = [companyId]
        }
        delete params.brandSeriesModel
        delete params.companyId
        // 添加tab参数
        const tabParams = tabList[TABS.WaitForHandle].params
        params = {
          ...params,
          ...tabParams,
        }
        const { groupType, itemType } = autoQuery?.g || {}
        params.groupType = groupType
        params.itemType = itemType
        return params
      },
      customizeReset: () => {
        table.value.setItemData({
          elConfigKey: 'value',
          key: 'brandSeriesModel',
          data: {},
        })
      },
    },
    tableData: {
      columns: [{
        name: 'data',
        columnProps: {
          prop: 'data',
          wordClass: 'wait-for-handle-card',
        },
        render({ row }) {
          const events = {}
          OPERATES.forEach((item) => {
            events[item] = operations[item].handler
          })
          return h('WaitForHandleCard', {
            props: {
              data: row,
            },
            on: {
              ...events,
              editUnRentableTags: operations.editUnRentableTag.handler,
            },
          })
        },
      }],
      apiFn: getCarListV2,
      showHeader: false,
      highlightCurrentRow: false,
    },
    isShowCompany: false,
  }
}
